import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=7c406a26&scoped=true"
import script from "./AttributeTable.vue?vue&type=script&lang=js"
export * from "./AttributeTable.vue?vue&type=script&lang=js"
import style0 from "./AttributeTable.vue?vue&type=style&index=0&id=7c406a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c406a26",
  null
  
)

export default component.exports